export default "__VITE_ASSET__6d5957ad__"